import { useNavigate } from 'react-router-dom'
import Chat from './ai/Chat'
import Icon from '../ui/icons'
import ComingSoon from '../screens/ComingSoon'
import { ROUTE_BY_PATH } from './routes'

// The dock follows the full page's `comingSoon` flag, so both ship together.
const aiRoute = ROUTE_BY_PATH.aiassistant

/** The slide-over dock — the same chat as the full page, in compact mode. */
export default function AiDock({ open, onClose }) {
  const navigate = useNavigate()

  
  return (
    <div className={`ai-dock${open ? ' open' : ''}`} id="aiDock">
      <div className="ai-dock-inner">
        {open && (
          <>
            <div className="card-head" style={{ borderRadius: 0 }}>
              <div>
                <h3><Icon name="sparkles" /> AI Assistant</h3>
              </div>
              <div className="flex items-center gap-8">
                <button
                  className="btn btn-ghost btn-sm"
                  onClick={() => {  
                    onClose()
                    navigate('/aiassistant')
                  }}
                >
                  Expand
                </button>
                <button className="modal-close" onClick={onClose} aria-label="Close">
                  <Icon name="x" />
                </button>
              </div>
            </div>
            <div style={{ flex: 1, padding: 16, overflow: 'hidden', display: 'flex' }}>
              {aiRoute.comingSoon ? (
                <ComingSoon route={aiRoute}><Chat compact /></ComingSoon>
              ) : (
                <Chat compact />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
